import { routes } from "./Routes";
import { RoleService } from "../../services/RoleService";

export interface IGatedRoute {
  route: string;
  canShow: () => boolean;
}

export const GATED_ROUTES: IGatedRoute[] = [
  {
    route: routes.DISTRIBUTION_SETTLEMENT,
    canShow: () => RoleService.canShowSettlementDistributionSection(),
  },
];

export const findBlockedGatedRoute = (
  pathname: string
): IGatedRoute | undefined =>
  GATED_ROUTES.find(
    (gated) => pathname.startsWith(gated.route) && !gated.canShow()
  );

export const filterMenuByGatedRoutes = <T extends { link?: string }>(
  menu: T[]
): T[] =>
  menu.filter(
    (item) =>
      !GATED_ROUTES.some(
        (gated) => item.link === gated.route && !gated.canShow()
      )
  );
